/**
 * テンプレートのデータ処理
 *
 */

import {
  deleteFirestoreDoc,
  getFirestoreDataWhereArrayAny,
  getFirestoreDataWhereIn,
  getFirestoreDocData,
  writeFirestoreDoc,
} from "../../../apis/firestoreAction";
import { firestore, getFirebaseUserInfo } from "../../../firebase";
import { userLogging } from "../../../apis/userLog";
import { TENPO_CHECK_ITEM_TEMPLATE, ZENKOKU_CODE } from "../Register/TenpoCheckTableDataOperation";

// テンプレート一覧取得
export const getTemplateData = async (
  conditions: string[],
  nationwideFlg: boolean
) => {
  let templateArray: TENPO_CHECK_ITEM_TEMPLATE[] = [];
  if (conditions.length === 0) {
    return templateArray;
  }
  const getTmpTempData = async (con: string[]) => {
    await getFirestoreDataWhereArrayAny(
      "tenpo_check_items_template",
      "attribution.conditions",
      con
    ).then((response: any) => {
      response.forEach((res: any) => {
        let data = res.data();
        let docID = data.doc_id;
        let bigItemId = data.attribution.big_item_id;
        let skipFlg = false;
        for (let i = 0; i < templateArray.length; i++) {
          if (docID === templateArray[i].doc_id) {
            skipFlg = true;
          }
        }
        if (skipFlg) {
          return;
        }
        if (
          (nationwideFlg && bigItemId !== 11) ||
          (!nationwideFlg && bigItemId !== 10)
        ) {
          return;
        }
        const templateValue: TENPO_CHECK_ITEM_TEMPLATE = {
          id: data.id,
          doc_id: data.doc_id,
          template_name: data.attribution.template_name,
          big_item_id: data.attribution.big_item_id,
          big_item_name: data.attribution.big_item_name,
          conditions: data.attribution.conditions,
          small_items: data.attribution.small_items,
          info: data.info,
        };
        templateArray.push(templateValue);
      });
      return templateArray;
    });
  };

  if (conditions && conditions.length > 10) {
    let workConditions = [];
    for (let i = 0; i < conditions.length; i++) {
      workConditions.push(conditions[i]);
      if (workConditions.length % 10 === 0 || i + 1 === conditions.length) {
        await getTmpTempData(workConditions);
        workConditions = [];
      }
    }
  } else {
    await getTmpTempData(conditions);
  }
  return templateArray;
};

// 適用中テンプレート取得
export const getUseTemplateData = async (conditions: string[]) => {
  let resultMap: any = {};
  if (conditions.length === 0) {
    return resultMap;
  }
  const getTmpTempData = async (con: string[]) => {
    await getFirestoreDataWhereIn(
      "tenpo_check_items_template",
      "doc_id",
      con
    ).then((response: any) => {
      resultMap = {};
      response.forEach((res: any) => {
        let data = res.data();
        let targetTempleteId = data.attribution.target_doc_id;
        resultMap.docID = targetTempleteId;
      });
      return resultMap;
    });
  };
  await getTmpTempData(conditions);
  return resultMap;
};

// テンプレートのFirestoreデータ更新を行う
export const updateTenpoCheckTemplate = async (
  templateItem: TENPO_CHECK_ITEM_TEMPLATE,
  newFlg?: boolean
) => {
  const objects: any = {};
  objects["attribution"] = {
    big_item_id: templateItem.big_item_id,
    big_item_name: templateItem.big_item_name,
    template_name: templateItem.template_name,
    conditions: templateItem.conditions,
    small_items: templateItem.small_items,
  };
  objects["id"] = templateItem.id;
  objects["doc_id"] = templateItem.doc_id;
  objects["info"] = {
    create_date: newFlg
      ? firestore.FieldValue.serverTimestamp()
      : templateItem.info
      ? templateItem.info.create_date
      : null,
    create_user: newFlg
      ? getFirebaseUserInfo().uid
      : templateItem.info
      ? templateItem.info.create_user
      : "",
    update_date: firestore.FieldValue.serverTimestamp(),
    update_user: getFirebaseUserInfo().uid,
  };
  userLogging(
    "店舗確認表",
    "新規作成#tenpo_check_items_templateテーブル更新",
    JSON.stringify(objects)
  );
  writeFirestoreDoc("tenpo_check_items_template", templateItem.doc_id, objects);
};

// テンプレートのFirestoreデータ削除を行う
export const deleteTenpoCheckTemplate = async (doc_id: string) => {
  deleteFirestoreDoc("tenpo_check_items_template", doc_id);
};

// 適用するテンプレートのFirestoreデータ更新を行う
export const updateTenpoCheckApplyTemplate = async (
  targetDocId: string,
  code: any,
  nationwideFlg: boolean
) => {
  let objects: any = {};
  let newFlg = false;
  let targetObject = {
    target_doc_id: targetDocId,
  };
  let targetCode = code;
  if (nationwideFlg) {
    targetCode = ZENKOKU_CODE; // 全国
  }

  // テンプレートの取得を行う
  const templateRecord = await getFirestoreDocData(
    "tenpo_check_items_template",
    targetCode
  ).then((response: any) => {
    return response;
  });
  if (templateRecord) {
    objects = templateRecord;
  } else {
    objects["id"] = targetCode;
    objects["doc_id"] = targetCode;
    objects["attribution"] = {};
    newFlg = true;
  }
  objects["attribution"] = targetObject;

  objects["info"] = {
    create_date: newFlg
      ? firestore.FieldValue.serverTimestamp()
      : templateRecord.info
      ? templateRecord.info.create_date
      : null,
    create_user: newFlg
      ? getFirebaseUserInfo().uid
      : templateRecord.info
      ? templateRecord.info.create_user
      : "",
    update_date: firestore.FieldValue.serverTimestamp(),
    update_user: getFirebaseUserInfo().uid,
  };
  userLogging(
    "店舗確認表",
    "新規作成#tenpo_check_items_templateテーブル更新",
    JSON.stringify(objects)
  );
  writeFirestoreDoc("tenpo_check_items_template", targetCode, objects);
};

// 引用作成のテンプレートのFirestoreデータ新規登録を行う
export const registTenpoCheckUseTemplateItem = async (
  docId: string,
  templateName: string,
  checkedUseItemList: any[],
  code: any,
  nationwideFlg: boolean,
) => {
  const objects: any = {};
  for (let i = 0; i < checkedUseItemList.length; i++) {
    checkedUseItemList[i].id = i + 1;
  }
  objects["attribution"] = {
    big_item_id: nationwideFlg ? 11 : 10,
    template_name: templateName,
    conditions: [code],
    small_items: checkedUseItemList,
  };
  objects["code"] = code;
  objects["id"] = docId;
  objects["doc_id"] = docId;
  objects["info"] = {
    create_date: firestore.FieldValue.serverTimestamp(),
    create_user: getFirebaseUserInfo().uid,
    update_date: firestore.FieldValue.serverTimestamp(),
    update_user: getFirebaseUserInfo().uid,
  };
  userLogging(
    "店舗確認表",
    "新規作成#tenpo_check_items_templateテーブル更新",
    JSON.stringify(objects)
  );
  writeFirestoreDoc("tenpo_check_items_template", docId, objects);
};
